import { buildProps, definePropType } from "../../../../utils/vue/props/runtime.mjs";

//#region ../../packages/components/date-picker-panel/src/props/basic-cell.ts
const basicCellProps = buildProps({ cell: { type: definePropType(Object) } });

//#endregion
export { basicCellProps };
//# sourceMappingURL=basic-cell.mjs.map